import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import ApplicationContext from "../../../context/index";
import NomineeAppointeeDetailsForm from "./indexForm";
import CircularProgress from "@mui/material/CircularProgress";
import useApi from "../../../hooks/useApi";
import isEmail from "validator/lib/isEmail";
import isMobilePhone from "validator/lib/isMobilePhone";
import { withStyles } from "@mui/styles";
import { Box } from "@mui/material";
import {
  convertToAge,
  getRoute,
  getStorageItem,
  isValidIFSC,
  makeid,
  reBuildBankList,
  setStorageItem,
} from "../../../helpers/utils";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import { postWebService } from "../../../helpers/server";
import { getMinDobDate, getMaxDobDate } from "../../../helpers/buyflow";
import {
  buildGenerateDocumentsPayload,
  buildSendDocumentsAndVerificationLinkPayload,
  buildUpdateNomineePayload,
  buildUpdateOrderPayload,
} from "../../../helpers/nominee";
import { ReducerUtils } from "../../../constants/reducers";
import { Utils } from "../../../constants/utils";
import { useHistory } from "react-router";
import { validations } from "../../../messages/validation";
import { useStyles } from "../indexFormStyles";
import {
  errorMessageObject,
  formObject,
  options,
  relationGenderMapping,
  sectionObject,
  touchFieldObject,
} from "../../../defaultValues/nominee";
import { CollectionsBookmarkRounded } from "@mui/icons-material";

function NomineeAppointeeDetails({ classes: { loaderBox } }) {
  const ERROR_MESSAGE = "Unable to proceed, kindly reachout to support team.";
  const banks = useApi(`banks-master.php`);
  // const relationdhips = useApi(`relationships.php`);
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const [backdrop, setBackdrop] = useState(false);
  const [errorMessage, setErrorMessage] = useState({ ...errorMessageObject });
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({ ...formObject });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [modal, setModal] = useState({ open: false });
  const [section, setSection] = useState({ ...sectionObject });
  const [touchFields, setTouchFields] = useState({ ...touchFieldObject });
  const [selectedBankOption1, setSelectedBankOption1] = useState(null);
  const [selectedBankOption2, setSelectedBankOption2] = useState(null);
  const [customerDob, setCustomerDob] = useState("");
  const [ageGap, setAgeGap] = useState(null);
  const [dateRange, setDateRange] = useState({
    nominee: {
      min: "",
      max: new Date().toISOString().split("T")[0],
    },
    appointee: {
      min: "",
      max: "",
    },
  });

  const relationships = {
    nominee: [
      {
        title: "Wife",
        value: "Wife",
        gap: "+0",
        generation: "same",
      },
      {
        title: "Husband",
        value: "Husband",
        gap: "+0",
        generation: "same",
      },
      {
        title: "Daughter",
        value: "Daughter",
        gap: "+15",
        generation: "younger",
      },
      {
        title: "Son",
        value: "Son",
        gap: "+15",
        generation: "younger",
      },
      {
        title: "Mother",
        value: "Mother",
        gap: "-15",
        generation: "elder",
      },
      {
        title: "Father",
        value: "Father",
        gap: "-15",
        generation: "elder",
      },
    ],
    appointee: [
      {
        title: "Mother",
        value: "Mother",
        gap: "-15",
        generation: "elder",
      },
      {
        title: "Father",
        value: "Father",
        gap: "-15",
        generation: "elder",
      },
      {
        title: "Grandfather",
        value: "Grandfather",
        gap: "-30",
        generation: "elder",
      },
      {
        title: "Grandmother",
        value: "Grandmother",
        gap: "-30",
        generation: "elder",
      },
    ],
  };

  useEffect(() => {
    async function getOrder() {
      try {
        const checksum = makeid();
        const response = await postWebService("orders.php", {
          checksum,
          oid: getStorageItem("oid"),
        });
        const { data } = response;
        const str = data.data.slice(9, -8);
        const result = JSON.parse(atob(str));
        if (result.checksum === checksum) {
          setCustomerDob(result?.dob ?? "");
        }
      } catch (error) {
        setIsLoaded(true);
      }
    }

    async function wrapperToken() {
      try {
        const header = buildWrapperTokenHeader();
        const response = await postWebService("token.php", {}, header);

        setStorageItem("access-token", response.data.access_token);
        getOrder();
      } catch (error) {
        // console.log(error);
      }
    }

    wrapperToken();
  }, []);

  useEffect(() => {
    dispatchEvent(
      ReducerUtils.bank.list,
      banks?.length > 0 ? reBuildBankList(banks) : []
    );
    setTimeout(() => setIsLoaded(true), 100);
  }, [banks]);
  useEffect(() => buildAgeGapObject(), [customerDob]);
  useEffect(() => {}, [dateRange]);
  useEffect(() => {
    ageGap && setIsLoaded(true);
  }, [ageGap]);
  useEffect(() => validateRequiredInput("nominee_name"), [form.nominee_name]);
  useEffect(() => {
    validateRequiredInput("nominee_relationship");
    setForm({
      ...form,
      nominee_dob: "",
      ...(form.nominee_relationship && {
        nominee_gender: relationGenderMapping[form.nominee_relationship],
      }),
    });
    ageGap && onChangeRelationship("nominee", form.nominee_relationship);
  }, [form.nominee_relationship]);
  useEffect(() => {
    validateMobile("nominee_mobile");
  }, [form.nominee_mobile]);
  useEffect(() => validateEmail("nominee_email"), [form.nominee_email]);
  useEffect(() => {
    validateDateOfBirth("nominee_dob", 0, 100);
    setFormState("nominee_age", convertToAge(form.nominee_dob));
  }, [form.nominee_dob]);
  // useEffect(() => {
  //   setForm({ ...form, nominee_relationship: "", nominee_gender: "" });
  // }, [form.nominee_age]);

  useEffect(
    () => validateRequiredInput("nominee_bank_account_holder_name"),
    [form.nominee_bank_account_holder_name]
  );
  useEffect(
    () => validateRequiredInput("nominee_bank_account_number"),
    [form.nominee_bank_account_number]
  );
  useEffect(() => {
    validateIFSCCode("nominee_bank_ifsc_code");
  }, [form.nominee_bank_ifsc_code]);

  useEffect(
    () => validateRequiredInput("appointee_name"),
    [form.appointee_name]
  );
  useEffect(() => {
    validateRequiredInput("appointee_relationship");
    setForm({
      ...form,
      appointee_dob: "",
      ...(form.appointee_relationship && {
        appointee_gender: relationGenderMapping[form.appointee_relationship],
      }),
    });
    ageGap && onChangeRelationship("appointee", form.appointee_relationship);
  }, [form.appointee_relationship]);
  useEffect(
    () => validateDateOfBirth("appointee_dob", 18, 100),
    [form.appointee_dob]
  );
  useEffect(() => validateMobile("appointee_mobile"), [form.appointee_mobile]);
  useEffect(() => validateEmail("appointee_email"), [form.appointee_email]);

  useEffect(
    () => validateRequiredInput("appointee_bank_account_holder_name"),
    [form.appointee_bank_account_holder_name]
  );
  useEffect(
    () => validateRequiredInput("appointee_bank_account_number"),
    [form.appointee_bank_account_number]
  );
  useEffect(() => {
    validateIFSCCode("appointee_bank_ifsc_code");
  }, [form.appointee_bank_ifsc_code]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const buildCommonObject = (ageGap = {}, list = []) => {
    list.forEach((rel) => {
      ageGap[rel.value] = {};
      ageGap[rel.value] = { min: rel.gap, generation: rel.generation };
    });
  };

  const buildAgeGapObject = () => {
    const object = {};

    buildCommonObject(object, relationships.nominee);
    buildCommonObject(object, relationships.appointee);
    setAgeGap({ ...object });
  };

  const adjustAgeGap = (dobStr = "", ageGapStr = "") => {
    const baseDate = new Date(dobStr);
    const gapYears = parseInt(ageGapStr.replace("+", "").replace("-", ""), 10);
    const isNegative = ageGapStr.startsWith("-");
    const adjustedDate = new Date(baseDate);
    adjustedDate.setFullYear(
      baseDate.getFullYear() + (isNegative ? -gapYears : gapYears)
    );
    const age = new Date().getFullYear() - adjustedDate.getFullYear();
    if (age < 18) {
      ageGapStr = "-18";
    }

    return ageGapStr;
  };

  const onChangeRelationship = (section = "nominee", relationship = "") => {
    const nomineeDob = new Date(form?.nominee_dob)
      .toLocaleDateString("en-GB")
      .replace(/\//g, "/");
    const gapObject = ageGap[relationship];
    let ageGapMin = gapObject?.min;
    console.log(ageGapMin);

    if (section === "appointee" && ageGapMin === "-15") {
      ageGapMin = adjustAgeGap(nomineeDob, ageGapMin);
    }

    const range = getDobRange(
      section === "nominee" ? customerDob : nomineeDob,
      ageGapMin,
      gapObject?.generation
    );
    console.log(range);

    const rangeObject = { [section]: { min: range?.min, max: range?.max } };

    setDateRange({ ...dateRange, ...rangeObject });
  };

  const parseDate = (dobStr = "") => {
    // Expects "dd/mm/YYYY"
    const [day, month, year] = dobStr.split("/").map(Number);
    return new Date(year, month - 1, day);
  };

  const formatDate = (date = null) => {
    // Returns "YYYY-MM-DD" for HTML date input
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const getDobRange = (dobStr = "", ageGapStr = "", generation = "same") => {
    const dob = parseDate(dobStr);
    const gap = parseInt(ageGapStr, 10);

    // Calculate new DOB by adding/subtracting the gap in years
    const newDob = new Date(dob);
    newDob.setFullYear(dob.getFullYear() + gap);

    let min = "",
      max = "";

    if (generation === "younger") {
      min = formatDate(newDob);
      max = new Date().toISOString().split("T")[0];
    } else if (generation === "elder") {
      min = getMinDobDate(150);
      max = formatDate(newDob);
    } else {
      min = getMinDobDate(150);
      max = getMaxDobDate(18);
    }

    return {
      min,
      max,
    };
  };

  const handleAccordionChange = (keyname, flag) => {
    const shallowCopy = { ...section };
    for (const key in shallowCopy) {
      if (keyname != key) {
        shallowCopy[key] = false;
      }
    }
    shallowCopy[keyname] = !flag;
    setSection(shallowCopy);
  };

  const handleChange = (event) =>
    setFormState(event.target.name, event.target.value);

  const handleCheckboxChange = (event) =>
    setFormState([event.target.name], event.target.checked);

  const handleChangeChipSelect = (name, value) => setFormState(name, value);

  const handleBack = () => navigateTo(getRoute("proposalDetails"));

  const navigateTo = (pathname) => history.push({ pathname });

  const setFormState = (name, value) => setForm({ ...form, [name]: value });

  const setErrorMessageState = (name, value) =>
    setErrorMessage({ ...errorMessage, [name]: value });

  const setTouchFieldsState = (name, value) =>
    setTouchFields({ ...touchFields, [name]: value });

  const setStateVariables = (key, isValid, message) => {
    setFormState("hasError", !isValid);
    setErrorMessageState(key, message);
    setTouchFieldsState(key, true);
  };

  const validateDateOfBirth = (fieldName, min, max) => {
    if (form[fieldName]) {
      const minDate = getMinDobDate(max);
      const maxDate = getMaxDobDate(min);

      if (!moment(form[fieldName]).isSameOrAfter(minDate)) {
        setErrorMessageState(fieldName, validations[fieldName].max);
      } else if (!moment(form[fieldName]).isSameOrBefore(maxDate)) {
        setErrorMessageState(fieldName, validations[fieldName].min);
      } else {
        setTouchFieldsState(fieldName, true);
        setErrorMessageState(fieldName, "");
      }
    } else if (touchFields[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateInputLength = (event) => {
    let elName = event.target.name;
    let elValue = event.target.value;

    if (
      event.target.name === "nominee_mobile" ||
      event.target.name === "appointee_mobile" ||
      event.target.name === "nominee_bank_account_number" ||
      event.target.name === "appointee_bank_account_number"
    ) {
      var clean = elValue.replace(/[^0-9]+/g, "");
      event.target.value = clean;
    }

    if (
      event.target.name === "nominee_bank_account_holder_name" ||
      event.target.name === "appointee_bank_account_holder_name" ||
      event.target.name === "nominee_name" ||
      event.target.name === "appointee_name"
    ) {
      var clean = elValue.replace(/[^A-Za-z\s]+/g, "");
      event.target.value = clean;
    }

    if (elValue.length > Utils.limit.digits[elName]) {
      event.target.value = elValue.substring(0, Utils.limit.digits[elName]);
    }
  };

  const validateRequiredInput = (fieldName) => {
    if (form[fieldName]) {
      setTouchFieldsState(fieldName, true);
      setErrorMessageState(fieldName, "");
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateMobile = (fieldName) => {
    if (form[fieldName]) {
      let isValid = isMobilePhone(form[fieldName], ["en-IN"]);
      setStateVariables(
        fieldName,
        isValid,
        isValid ? "" : validations[fieldName].valid
      );
    } else if (touchFields[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const validateEmail = (fieldName) => {
    if (form[fieldName]) {
      let isValid = isEmail(form[fieldName]);
      setStateVariables(
        fieldName,
        isValid,
        isValid ? "" : validations[fieldName].valid
      );
    } else if (touchFields[fieldName]) {
      setErrorMessageState(fieldName, "");
    }
  };

  const validateIFSCCode = (fieldName) => {
    if (form[fieldName]) {
      const isValid = isValidIFSC(form[fieldName]);
      if (isValid) {
        setTouchFieldsState(fieldName, true);
        setErrorMessageState(fieldName, "");
      } else {
        setErrorMessageState(fieldName, validations[fieldName].valid);
      }
    } else if (touchFields[fieldName] && !form[fieldName]) {
      setErrorMessageState(fieldName, validations[fieldName].required);
    }
  };

  const cbError = (error) => {
    setIsFormSubmitted(false);
    setBackdrop(false);
  };

  const sendDocumentsAndVerificationLink = async () => {
    try {
      const response = await postWebService(
        "sendconfirmationcoi.php",
        buildSendDocumentsAndVerificationLinkPayload()
      );

      const { data } = response.data;
      updateOrderStatus("PENDINGPROPOSALCONFIRMATION");
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessErrorGenerateDocuments = (data) => {
    if (data?.code === 200) {
      updateOrderStatus("NOMINEEDETAIL");
    } else {
      setIsFormSubmitted(false);
      setBackdrop(false);
      setErrors([data?.message ?? ERROR_MESSAGE]);
    }
  };

  const generateDocuments = async () => {
    try {
      const response = await postWebService(
        "generateDocuments-upf.php",
        buildGenerateDocumentsPayload()
      );

      cbSuccessErrorGenerateDocuments(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessUpdateOrder = (data, status) => {
    if (status === "PENDINGPROPOSALCONFIRMATION") {
      setIsFormSubmitted(false);
      setBackdrop(false);
      navigateTo(getRoute("reviewDetails"));
    } else if (status === "NOMINEEDETAIL") {
      sendDocumentsAndVerificationLink();
    }
  };

  const updateOrderStatus = async (status) => {
    try {
      const response = await postWebService(
        "update-order.php",
        buildUpdateOrderPayload(status)
      );

      const { data } = response.data;
      cbSuccessUpdateOrder(data, status);
    } catch (error) {
      cbError(error);
    }
  };

  const updateNomineeAppointeeDetails = async () => {
    try {
      setIsFormSubmitted(true);
      setBackdrop(true);
      setErrors([]);
      const response = await postWebService(
        "nominee.php",
        buildUpdateNomineePayload(
          form,
          selectedBankOption1,
          selectedBankOption2
        )
      );

      const { data } = response.data;
      generateDocuments();
    } catch (error) {
      cbError(error);
    }
  };

  const onSubmit = (event) => {
    event.preventDefault();

    updateNomineeAppointeeDetails();
  };

  return isLoaded && ageGap ? (
    <NomineeAppointeeDetailsForm
      backdrop={backdrop}
      banks={banks}
      dateRange={dateRange}
      errorMessage={errorMessage}
      errors={errors}
      form={form}
      handleAccordionChange={handleAccordionChange}
      handleBack={handleBack}
      handleChange={handleChange}
      handleCheckboxChange={handleCheckboxChange}
      handleChangeChipSelect={handleChangeChipSelect}
      isFormSubmitted={isFormSubmitted}
      modal={modal}
      options={options}
      onSubmit={onSubmit}
      section={section}
      selectedBankOption1={selectedBankOption1}
      setSelectedBankOption1={setSelectedBankOption1}
      selectedBankOption2={selectedBankOption2}
      setSelectedBankOption2={setSelectedBankOption2}
      validateInputLength={validateInputLength}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  NomineeAppointeeDetails
);
